import { ICartEntry, IComboSlotOption, IItem, IPrices } from '@rbi-ctg/menu';
import { IWithVendorConfig, PosVendors } from 'utils/vendor-config';

import { pricingFunctionNoSelections } from './pricing-function-no-selections';

export const priceForPremiumComboSlotDelta = (
  defaultComboSlotOption: IComboSlotOption | undefined,
  selectedItem: ICartEntry | IItem,
  prices: IPrices,
  vendor: PosVendors | null
) => {
  // get price of default option
  const defaultPrice = defaultComboSlotOption
    ? pricingFunctionNoSelections(defaultComboSlotOption?.option, prices, vendor)
    : 0;
  // subtract the price of the default from the premiumOption
  const delta =
    pricingFunctionNoSelections(selectedItem as IWithVendorConfig, prices, vendor) - defaultPrice;
  // If delta is negative the price is zero
  return delta > 0 ? delta : 0;
};
